export default "__VITE_ASSET__07ea6254__"